import Design1 from './design-1';
import {useContext, useEffect, useState} from "react";
import axios from "axios";
import {filterItems} from "../../utils/utils";
import {WebsiteContext} from "../../index";
import useApplyUserDefinedListOverrides from "../../hooks/use-user-defined-list-sort";

ProductsBlock.propTypes = {};

ProductsBlock.defaultProps = {};

const designs = [Design1];

export default function ProductsBlock(props) {
    const context = useContext(WebsiteContext);
    const DesignBlock = designs[props.values?.design] ?? Design1;
    const [items, setItems] = useState(() => filterItems(props?.values?.items || []));
    const [state, setState] = useState(() => {
        if (!context.builder && items.length === 0) return props?.values?.emptyState;
    });

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();
        if (context.builder) {
            axios
                .post(`/api/v2/website/products`, {...props?.values}, {
                    headers: {"X-Preview-Domain": `${location.protocol}//${context?.website?.previewDomain}`},
                    cancelToken: cancelToken.token,
                })
                .then(({data}) => {
                    if (data?.items?.length > 0) {
                        setItems(data?.items)
                        setState(null)
                    } else setState(props?.values?.emptyState)
                })
                .catch((err) => {
                    if (!axios.isCancel(err)) console.error("Failed to fetch products data:", err)
                })
        }
        return () => cancelToken.cancel();
    }, [props?.values]);

    const values = useApplyUserDefinedListOverrides({
        ...props,
        items,
        itemsPositions: props?.values?.itemsPositions
    });

    return (
        <DesignBlock {...props} values={values} state={state}/>
    )
};